/**
 * Sticky header functionality
 *
 * @package Embark
 * @since   1.0.0
 */

import { els } from './variables';

/**
 * Tracks the current scroll position on the page.
 *
 * @type {Number}
 */
let currentScrollPoint;

/**
 * The point (in pixels) at which the header class should be toggled.
 * @todo factor in document.querySelector('.site-alert-banner').offsetHeight without bouncing.
 *
 * @type {Number}
 */
const headerScrollPoint = 5;

/**
 * Toggle the header scrolled class.
 */
function maybeToggleScrolledClass() {
	/**
	 * Update the current scroll position.
	 *
	 * @type {Number}
	 */
	currentScrollPoint = (els.html && els.html.scrollTop) || els.body.scrollTop;

	/**
	 * Check scroll status and toggle .scrolled accordingly.
	 */
	if (currentScrollPoint >= headerScrollPoint) {
		els.header.classList.add('scrolled');
	} else {
		els.header.classList.remove('scrolled');
	}
}

window.addEventListener('scroll', maybeToggleScrolledClass, { passive: true });
window.addEventListener('load', maybeToggleScrolledClass);
